import React, { Ref, useMemo, forwardRef } from "react";

import classnames from "classnames";

import { StyledStep, StyledSteps } from "./Styles";

export interface IStepsProps {
  /** Number of steps */
  numberOfSteps: number;
  /** If not progressive, the index of the only active step. If progressive, the index of the last active steps */
  activeStep: number;
  /** Does the stepper can have only single active step */
  progressive?: boolean;
  /** Class for wrapper div */
  wrapperClassName?: string;
}

export const Steps = forwardRef(
  (
    {
      numberOfSteps,
      activeStep,
      progressive = false,
      wrapperClassName,
    }: IStepsProps,
    ref: Ref<HTMLDivElement> | null | undefined
  ) => {
    const steps = useMemo(() => {
      // fastest way to generate an array of N numbers
      const a: number[] = [];
      let b = numberOfSteps;
      while (b--) {
        a[b] = b + 1;
      }
      return a;
    }, [numberOfSteps]);

    const activeSteps = useMemo(() => {
      if (!progressive) {
        return [activeStep];
      }

      return steps.filter((step) => {
        return step <= activeStep;
      });
    }, [activeStep, progressive, steps]);

    return (
      <StyledSteps
        className={classnames("c-steps-wrapper", wrapperClassName)}
        ref={ref}
      >
        {steps.map((step) => {
          return (
            <StyledStep
              key={`step-${step}`}
              $isActiveStep={activeSteps.indexOf(step) > -1}
            />
          );
        })}
      </StyledSteps>
    );
  }
);

Steps.displayName = "Steps";
